// i18n area 'backups' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da archive.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/backups.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './backups'

export const ptBR: DeepPartial<typeof enUS> = {
  ckpt: {
    storageHint: 'Um storage dir-like (dir/NFS/CIFS/CephFS) — os artefactos são arquivos normais sob o namespace da plataforma.',
    retentionHint: 'Quantos checkpoints agendados manter — o sweeper remove os mais antigos para além da contagem. Os checkpoints manuais e pré-restauração nunca são removidos.',
    masterpassHint: 'Protege os valores secretos do keystore (argon2id → AES-256-GCM, por valor). Nunca é guardada: conserve-a — sem ela, uma restauração produz placeholders em vez dos segredos verdadeiros.',
    originPreRestore: 'pré-restauração',
    preChangeRetentionHint: 'Vazio = desativado. A primeira escrita de configuração após um período de calma congela aqui o estado anterior (origem pré-alteração); os mais recentes são mantidos até a contagem — retenção própria, podável.',
    diffTitle: 'Prévia das alterações',
    diffFailed: 'Falha na prévia',
    diffRetry: 'Tentar de novo',
    diffExtra: 'seria excluído',
    diffJsonb: 'referências jsonb não verificáveis antes de aplicar',
    diffNeeded: 'O início se arma quando a prévia reflete a seleção.',
    uploadFile: 'Carregar um arquivo .tvbk',
    uploading: 'Enviando…',
    otherCluster: 'Este checkpoint provém de OUTRO cluster ({cluster}) — a restauração cross-cluster chega num round futuro.',
    parachuteHint: 'Antes de tocar em qualquer linha, a task cria aqui um checkpoint automático pré-restauração.',
    confirmHint: 'Digite o nome do cluster ({name}) para confirmar — uma restauração reescreve a configuração declarada.',
    restoreFailed: 'A restauração falhou',
    rescanHint:
      'Reconstrói o catálogo de cópias (VM/CT/App) a partir dos manifestos dos artefactos presentes no destino. As linhas existentes nunca são tocadas; as cópias de políticas desconhecidas ficam órfãs (nunca podadas automaticamente). O gesto após uma restauração de bootstrap.',
    masterpassDrWarning:
      'Cenário de desastre: os discos LUKS só voltam de um checkpoint COM masterpass. Os checkpoints agendados empacotam marcadores — tire periodicamente um checkpoint manual com masterpass.'
  },
  backup: {
    intro: {
      whatItIsNot: 'O TVirt não é um produto de backup: não agenda nada, não aplica retenção e não guarda nenhuma cópia dos seus dados. Retenção, catálogos e políticas de restauração ficam com o software que já usa.'
    }
  }
}
